import { createFileRoute } from '@tanstack/react-router';
import { DocumentsScreen } from '../../../features/documents/documents-screen';

export const Route = createFileRoute('/_authenticated/documente/')({
  component: DocumentsScreen,
});
